import { useState, useCallback } from 'react';
import * as zionManagementAction from "../redux/store-sarang/zion/zion-management.store";

export const useLookupZion = () => {
    const [zion, setZion] = useState([]);

    const getLookupZion = useCallback(async () => {
        try {
            const res = await zionManagementAction.GetLookupZion();
            if (res && res.content) {
                setZion(res.content);
                return res.content;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    return { zion, getLookupZion };
};
